export * from './paragraph-component-config.interface';
